"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
var program_list_1 = require("../../components/program/program-list");
require("./programs.scss");
var Programs = function (_a) {
    var orgId = _a.match.params.orgId;
    return (React.createElement("div", { id: "programs", className: "container hub-full-width" },
        React.createElement("div", { className: "page-content u-xs-padXl u-flexExpandSides" },
            React.createElement("div", { className: "page-content-header Grid u-flexAlignItemsCenter" },
                React.createElement("div", { className: "Grid-cell u-xs-size1of2" },
                    React.createElement("h1", null, "Programs")),
                React.createElement("div", { className: "Grid-cell u-xs-size1of2 u-textRight button-list" },
                    React.createElement(react_router_dom_1.Link, { to: "/organizations/" + orgId + "/programs-report" },
                        React.createElement(teamsnap_ui_1.Button, null, "Show Programs Report")),
                    React.createElement(react_router_dom_1.Link, { to: "/organizations/" + orgId + "/programs/new" },
                        React.createElement(teamsnap_ui_1.Button, { color: "primary", icon: "plus", iconPosition: "left" }, "Create New Program")))),
            React.createElement("div", { className: "page-content-body" },
                React.createElement(program_list_1.default, { orgId: +orgId })))));
};
exports.default = Programs;
//# sourceMappingURL=programs.js.map